import { useMutation } from '@tanstack/react-query';
import { queryKeys } from 'queryKeys';
import authSessionService from 'services/authSession';
import userService from 'services/user';
import { BLINKET_APP_URL } from 'settings';

export function useLoginAsEmailMutation() {
  return useMutation({
    mutationKey: queryKeys.layout.loginAsEmail(),
    mutationFn: (email: string) => userService.loginAsEmail(email),
    onSuccess: logged => {
      const { jwt_token: token, jwt_refresh_token: refresh } = logged;
      authSessionService.setTokens({ token, refresh });
      window.location.assign(`${BLINKET_APP_URL}/home`);
    }
  });
}
